import { css } from '@/styled-system/css';

export const leadManagementHeaderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  paddingBlock: 'default',
  marginTop: 'default',
  gap: 'default',
});

export const leadManagementTitleRowStyles = css.raw({
  marginTop: 'loose',
  marginBottom: { xlDown: 'default', xl: 'loose' },
  display: 'flex',
  // Stack the title and button on phones so the button label doesn't get squeezed.
  flexDirection: { base: 'column', md: 'row' },
  alignItems: { base: 'flex-start', md: 'center' },
  justifyContent: 'space-between',
  gap: 'default',
});

export const leadManagementTitleActionsStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'default',
});

// Listing and source selectors sharing a row above the header; stacked on phones.
export const leadManagementScopeRowStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', md: 'row' },
  alignItems: { md: 'center' },
  gap: 'default',
});
